export const TOGGLE_SIDE_BAR = 'TOGGLE_SIDE_BAR';
